<template>
  <base-dialog width="800px" :visible.sync="visible" class="subprocess-dialog">
    <template v-slot:header>
      <div class="title">
        <span>{{ name + "  ( " + count + " )" }}</span>
      </div>
    </template>
    <div class="history-list" v-loading="loading">
      <div class="history-item">
        <div class="index">索引</div>
        <div class="date">日期</div>
        <div class="var">变量</div>
      </div>
      <div
        v-for="(item, index) in subprocessHistory"
        :key="index"
        class="history-item"
        @click="getDetail(item)"
      >
        <div class="index">{{ index }}</div>
        <div class="date">{{ item.date }}</div>
        <div class="var" v-tip>{{ item.var }}</div>
      </div>
    </div>
    <subprocess-detail-dialog ref="subprocess"></subprocess-detail-dialog>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog"
import { getSubProcessVars } from "@/api/workflow/processHistory"
import SubprocessDetailDialog from "@/views/Backend/AdminEdit/Workflow/components/SubprocessDetailDialog"

export default {
  name: "subprocess-dialog",
  components: { SubprocessDetailDialog, BaseDialog },
  data() {
    return {
      visible: false,
      subprocessHistory: [],
      loading: false,
      name: "",
      count: 0
    }
  },
  methods: {
    open(item) {
      let processInstId = item.processInstId
      this.name = item.name
      let subProcessId = item.id
      this.visible = true
      this.loading = true
      getSubProcessVars(processInstId, subProcessId).then(res => {
        this.subprocessHistory = res
        this.count = this.subprocessHistory.length
        this.loading = false
      })
    },
    getDetail(activity) {
      this.$nextTick(() => {
        this.$refs.subprocess?.open(activity)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.subprocess-dialog {
  .history-list {
    height: 500px;
    .history-item {
      border-bottom: 1px solid #ddd;
      padding: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      &:hover {
        background-color: #f6f8fa;
      }
      .index {
        width: 50px;
      }
      .date {
        width: 180px;
      }
      .var {
        flex: 1;
      }
    }
  }
  ::v-deep {
    .el-dialog__body {
      margin-bottom: 20px;
    }
  }
}
</style>
